import React from 'react';
import { Platform, Pressable } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { useTranslation } from '@/hooks/useTranslation';
import Icon from '@/components/Icon';
import * as DropdownMenu from '@/components/DropdownMenu/DropdownMenu';
import DropdownMenuItem from '@/components/DropdownMenu/DropdownMenuItem';

export default function MemoryItemActions({ onEdit, onCopy, onDelete, isCopied }) {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const items = [
    { title: t('settings.memory.editMemory'), icon: 'pen', iosIcon: 'pencil', onSelect: onEdit },
    { title: t(isCopied ? 'pages.memory.copied' : 'pages.memory.copyMemory'), icon: 'copy', iosIcon: 'doc.on.doc', onSelect: onCopy },
    { title: t('settings.memory.deleteMemory'), icon: 'trash', iosIcon: 'trash', onSelect: onDelete, isDanger: true },
  ];
  return <DropdownMenu.Root>
    <DropdownMenu.Trigger asChild={Platform.OS === 'web' || Platform.OS === 'macos'}>
      <Pressable accessibilityRole="button" accessibilityLabel={t('pages.memory.memoryActions')}
        style={{ width: 36, height: 36, marginTop: -7, marginRight: -7, alignItems: 'center', justifyContent: 'center', borderRadius: 9 }}>
        <Icon name="ellipsis" size={15} color={colors.text_color_secondary} />
      </Pressable>
    </DropdownMenu.Trigger>
    <DropdownMenu.Content align="end" sideOffset={5} className={Platform.OS === 'web' ? 'DropdownMenuContent' : undefined}>
      {items.map(item => Platform.OS === 'web'
        ? <DropdownMenuItem key={item.icon} {...item} />
        : <DropdownMenu.Item key={item.icon} onSelect={item.onSelect} destructive={item.isDanger}>
          <DropdownMenu.ItemIcon ios={{ name: item.iosIcon }} />
          <DropdownMenu.ItemTitle>{item.title}</DropdownMenu.ItemTitle>
        </DropdownMenu.Item>)}
    </DropdownMenu.Content>
  </DropdownMenu.Root>;
}
